import { render, staticRenderFns } from "./VideoLive.vue?vue&type=template&id=467598b6&scoped=true"
import script from "./VideoLive.vue?vue&type=script&lang=js"
export * from "./VideoLive.vue?vue&type=script&lang=js"
import style0 from "./VideoLive.vue?vue&type=style&index=0&id=467598b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467598b6",
  null
  
)

export default component.exports